import { Box, Button, Typography } from "@mui/material";
import { CustomCheckBox } from "../../utils/CustomCheckBox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ButtonZoom } from "../../utils/ButtonZoom";
import * as React from "react";
import { makeStyles } from "@mui/styles";
import { Screens } from "../SelfRegistration";
import { generateGtmEvent } from "../../../../Helpers";

const useStyles = makeStyles((theme) => ({
  tosStyle: {
    marginBottom: "16px",
    "& button": {
      color: "inherit",
    },
  },
  btnContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  pad16: {
    padding: "0px 0px 16px 0px",
  },
  pad24: {
    padding: "0px 0px 24px 0px",
  },
  backButton: {
    padding: "0px",
    backgroundColor: "transparent",
    borderRadius: "8px",
    color: theme.palette.text.secondary,
    width: "90px",
    height: "45px",
    boxShadow: "none",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      width: "90px",
      height: "45px",
      textDecoration: "underline",
      color: theme.palette.text.primary,
      boxShadow: "none",
      transform: "none",
    },
  },
}));

interface StepZeroProps {
  isDisabled: boolean;
  checkedAge: boolean;
  handleAgeCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checkedConsent: boolean;
  handleConsentCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void;
  termsOfServiceText: any;
  handleBack: (e: React.MouseEvent<HTMLButtonElement>, page: Screens) => void;
  handleNext: (e: React.MouseEvent<HTMLButtonElement>, pageID: number) => void;
}

export const StepZero = (props: StepZeroProps) => {
  const classes = useStyles();
  const HandleDataLayer = (
    event: string,
    action: string,
    name: string,
    type: string,
    region: string,
    section: string,
    text: string
  ) => {
    generateGtmEvent({ event, action, name, type, region, section, text });
  };
  const {
    isDisabled,
    checkedAge,
    checkedConsent,
    handleConsentCheckbox,
    handleBack,
    handleAgeCheckbox,
    handleNext,
    termsOfServiceText,
  } = props;
  return (
    <div>
      <Typography component="p" className={classes.pad16} color="text.secondary">
        Please confirm you are 13 years old or older.
      </Typography>
      <Box className={classes.pad24}>
        <CustomCheckBox
          label={"I am 13 years old or older"}
          checked={checkedAge}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleAgeCheckbox(event);
          }}
          emitDataLayer={(checked) => {
            HandleDataLayer(
              "select",
              checked ? "click" : "unclick",
              "onclick",
              "checkbox",
              "main content",
              "create your account",
              "I am 13 years old or older"
            );
          }}
        />
      </Box>
      <div className={classes.pad24 && classes.tosStyle}>{termsOfServiceText}</div>
      <Box className={classes.pad24}>
        <CustomCheckBox
          label={"I CONSENT"}
          checked={checkedConsent}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleConsentCheckbox(event);
          }}
          emitDataLayer={(checked) => {
            HandleDataLayer(
              "select",
              checked ? "click" : "unclick",
              "onclick",
              "checkbox",
              "main content",
              "create your account",
              "I CONSENT"
            );
          }}
        />
      </Box>
      <div className={classes.btnContainer}>
        <Button
          size="medium"
          className={classes.backButton}
          variant="contained"
          sx={{ marginLeft: "-0.85em" }}
          startIcon={<ArrowBackIcon style={{ width: "16px", height: "16px" }} />}
          onClick={(e) => {
            HandleDataLayer(
              "link",
              "click",
              "onclick",
              "internal link",
              "main content",
              "create your account",
              "Back"
            );
            handleBack(e, "coursecode");
          }}>
          Back
        </Button>
        <ButtonZoom
          sx={{ width: "146px", height: "62px" }}
          disabled={isDisabled}
          type="submit"
          size="large"
          variant="contained"
          color="secondary"
          onClick={(e) => {
            HandleDataLayer(
              "link",
              "click",
              "onclick",
              "internal link",
              "main content",
              "create your account",
              "Continue"
            );
            handleNext(e, 1);
          }}>
          Continue
        </ButtonZoom>
      </div>
    </div>
  );
};
